import { render, staticRenderFns } from "./DesignRirekishoJobCategoryCard.vue?vue&type=template&id=1bd71642&scoped=true"
import script from "./DesignRirekishoJobCategoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekishoJobCategoryCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DesignRirekishoJobCategoryCard.vue?vue&type=style&index=0&id=1bd71642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd71642",
  null
  
)

export default component.exports